// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AboveFold_wrapper__1VG2t","bg":"AboveFold_bg__1rbTd"};